
export default {
  name: 'SharedContent',
  components: {
    SharedContentType: () => import('@/components/page/SharedContentType')
  },
  props: {
    blok: {
      required: true,
      type: Object
    }
  },
  computed: {
    componentIsAvailable() {
      return (
        this.blok.content &&
        this.blok.content.content &&
        this.blok.content.content.component
      )
    },
    checkPid() {
      return this.blok.product_id ? this.blok.product_id.selected : null
    }
  }
}
